var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modalPopupInfo",
      attrs: {
        size: "lg",
        title: "Aide au démarrage",
        scrollable: "",
        "no-close-on-backdrop": ""
      }
    },
    [
      _c("template", { slot: "default" }, [
        _c(
          "h5",
          { staticClass: "mb-3 mt-2", staticStyle: { "font-weight": "bold" } },
          [_vm._v("Comment passer votre première commande ?")]
        ),
        _c("div", [
          _c("h6", [_vm._v("Etape 1")]),
          _c("p", [_vm._v('Cliquez sur le menu "Commandes".')]),
          _c("div", { staticClass: "flex-center-center mb-3" }, [
            _c("div", { staticClass: "col-8" }, [
              _c("img", {
                staticClass: "border-black border-rounded w-100",
                attrs: {
                  src: require("../../assets/images/modalPopupInfo/etape1.png"),
                  alt: "Passer une commande étape 1"
                }
              })
            ])
          ]),
          _c("h6", [_vm._v("Etape 2")]),
          _c("p", [
            _vm._v('Cliquez sur le bouton "Créer une nouvelle commande".')
          ]),
          _c("div", { staticClass: "flex-center-center mb-3" }, [
            _c("div", { staticClass: "col-8" }, [
              _c("img", {
                staticClass: "border-black border-rounded w-100",
                attrs: {
                  src: require("../../assets/images/modalPopupInfo/etape2.png"),
                  alt: "Passer une commande étape 1"
                }
              })
            ])
          ]),
          _c("h6", [_vm._v("Etape 3")]),
          _c("p", [
            _vm._v('Donnez un nom à votre commande, et cliquer "Créer".')
          ]),
          _c("div", { staticClass: "flex-center-center mb-3" }, [
            _c("div", { staticClass: "col-8" }, [
              _c("img", {
                staticClass: "border-black border-rounded w-100",
                attrs: {
                  src: require("../../assets/images/modalPopupInfo/etape3.png"),
                  alt: "Passer une commande étape 1"
                }
              })
            ])
          ]),
          _c("h6", [_vm._v("Etape 4")]),
          _c("p", [
            _vm._v(
              'Cliquez sur "Choisir produits" pour accèder à la Mercuriale.'
            )
          ]),
          _c("div", { staticClass: "flex-center-center mb-3" }, [
            _c("div", { staticClass: "col-8" }, [
              _c("img", {
                staticClass: "border-black border-rounded w-100",
                attrs: {
                  src: require("../../assets/images/modalPopupInfo/etape4.png"),
                  alt: "Passer une commande étape 1"
                }
              })
            ])
          ]),
          _c("p", [
            _vm._v("Pour plus d'information, dirigez-vous vers nos pages \""),
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    return _vm.$router.push({ name: "DocCommandes" })
                  }
                }
              },
              [_vm._v("Aide")]
            ),
            _vm._v('". ')
          ])
        ])
      ]),
      _c("template", { slot: "modal-footer" }, [
        _c("label", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.nePlusAfficher,
                expression: "nePlusAfficher"
              }
            ],
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.nePlusAfficher)
                ? _vm._i(_vm.nePlusAfficher, null) > -1
                : _vm.nePlusAfficher
            },
            on: {
              change: function($event) {
                var $$a = _vm.nePlusAfficher,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.nePlusAfficher = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.nePlusAfficher = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.nePlusAfficher = $$c
                }
              }
            }
          }),
          _c("span", { staticClass: "ml-2" }, [_vm._v("Ne plus afficher")])
        ]),
        _c(
          "button",
          {
            staticClass: "btn btn-secondary ml-4",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.fermer()
              }
            }
          },
          [_vm._v(" Fermer ")]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }